import { LicenseCompartments, licenseStorageKey } from '..';
import { ApiKeys } from '../../../api/apis/ApiKeys';
import { LicenseAgreementApi } from '../../../api/apis/LicenseAgreementApi';
import { IMutation, MutationContext } from '@aesop-fables/scrinium';
import { OrganizationCompartments, organizationStorageKey } from '../../organization';
import {
  licenseAgreementAcceptLogCompartments,
  licenseAgreementAcceptLogStorageKey,
} from '../../licenseAgreementAcceptLog';
import { PricebookCompartments, pricebookStorageKey } from '../../pricebook';
import { RevShareCompartments, revShareStorageKey } from '../../rev-share';

export class AcceptLicenseAgreement implements IMutation<number> {
  async execute(context: MutationContext<number>): Promise<void> {
    const { data, storage, container } = context;
    const licenseAgreementApi = container.get<LicenseAgreementApi>(ApiKeys.LicenseAgreement);

    await licenseAgreementApi.accept(data);

    const licenseDataCache = storage.retrieve<LicenseCompartments>(licenseStorageKey);
    const organizationDataCache =
      storage.retrieve<OrganizationCompartments>(organizationStorageKey);
    const licenseAgreementAcceptLogDataCache =
      storage.retrieve<licenseAgreementAcceptLogCompartments>(licenseAgreementAcceptLogStorageKey);
    const revShareCache = storage.retrieve<RevShareCompartments>(revShareStorageKey);

    const pricebookDataCache = storage.retrieve<PricebookCompartments>(pricebookStorageKey);

    const reloads: Promise<void>[] = [
      licenseDataCache.reloadAll(),
      organizationDataCache.reload('allMetrics'),
      licenseAgreementAcceptLogDataCache.reload('licenseAgreementAcceptLog'),
      revShareCache.reload('orgRevShareSettings'),
    ];

    const teamInUseInitialized = pricebookDataCache
      .findCompartment('teamPricebooksInUse')
      .getCompartmentState().initialized;

    if (teamInUseInitialized) {
      reloads.push(pricebookDataCache.reload('teamPricebooksInUse'));
    }

    await Promise.all(reloads);
  }
}
